export const equalTableCols = (table) => {
  const firstColumn = table.querySelector('[data-table-column]');
  const firstColumnCells = firstColumn.querySelectorAll('[data-table-cell]');
  const cellsLength = firstColumnCells.length;

  for (let i = 0; i < cellsLength; i += 1) {
    let maxHeight = 0;

    const columns = table.querySelectorAll('[data-table-column]');

    columns.forEach((column) => {
      const cell = column.children[i];

      cell.style.minHeight = 'auto';
      const cellHeight = cell.offsetHeight;
      maxHeight = cellHeight > maxHeight ? cellHeight : maxHeight;
    });

    columns.forEach((column) => {
      const cell = column.children[i];
      cell.style.minHeight = `${maxHeight}px`;
    });
  }
};
